import { Color, Flex, Icon, IconName, Spacing, Switch, Text } from '@billy/design-system'
import { ReactElement } from 'react'

import { useInvoiceEditorForm } from '../../../../../../../../../../../../contexts/invoiceEditorFormContext'
import * as Styled from './styles'

interface PaymentMethodsListItemProps {
  details: string
  formValueName:
    | 'displayedPaymentMethods.bank'
    | 'displayedPaymentMethods.paypal'
    | 'displayedPaymentMethods.offlinePayment'
    | 'displayedPaymentMethods.stripeCardPayment'
  icon: IconName
  isDisabled?: boolean
  onToggle?: (checked: boolean) => void
  title: string
}

export const PaymentMethodsListItem = ({
  details,
  formValueName,
  icon,
  isDisabled,
  onToggle,
  title,
}: PaymentMethodsListItemProps): ReactElement => {
  const { invoiceEditorForm } = useInvoiceEditorForm()
  const { FormItem } = invoiceEditorForm

  return (
    <Styled.PaymentMethodsListItemWrapper>
      <Flex alignItems="center" justifyContent="space-between" gap={Spacing.S8}>
        <Flex alignItems="center" gap={Spacing.S8}>
          <Icon color={Color.Black} icon={icon} />
          <Text weight="bold" nowrap>
            {title}
          </Text>
        </Flex>
        <Styled.DetailsAndSwitchWrapper>
          <Flex alignItems="center" gap={Spacing.S12}>
            <Styled.DetailsWrapper>
              <Text colorVariant="secondary" variant="bodySM" truncate>
                {details}
              </Text>
            </Styled.DetailsWrapper>
            <FormItem
              name={formValueName}
              render={({ field: { value, onChange, ...props } }) => (
                <Switch
                  {...props}
                  aria-label={title}
                  checked={value}
                  disabled={isDisabled}
                  onChange={(event) => {
                    onChange(event)
                    onToggle?.(event.currentTarget.checked)
                  }}
                />
              )}
            />
          </Flex>
        </Styled.DetailsAndSwitchWrapper>
      </Flex>
    </Styled.PaymentMethodsListItemWrapper>
  )
}
